/* apps/viewer/src/app/media-module/player/player.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
::ng-deep .player-push-top,
::ng-deep .player-push-top #iframe iframe {
  height: calc(75vh - 95px) !important;
  transition: all ease 0.1s;
}
.player-container {
  height: calc(100vh - 60px);
  overflow: hidden;
  position: relative;
  transition: all ease 0.1s;
  visibility: hidden;
  width: 100%;
}
.player-container .iframe {
  height: calc(100vh - 60px);
  width: 100%;
}
.player-container .switch-view-button-container {
  bottom: 5px;
  position: absolute;
  right: 5px;
}
.player-container .switch-view-button-container button {
  border: 1px solid #00205b;
  border-right: 0;
  cursor: pointer;
  padding: 5px 10px;
}
.player-container .switch-view-button-container:last-child {
  border-right: 1px solid #00205b;
}
.player-container .switch-view-button-container .activate {
  background-color: #0082d5;
}
.player-container .switch-view-button-container .activate ::ng-deep svg {
  color: #fafafa;
}
.player-container .notes-button {
  position: absolute;
  right: 15px;
  top: 50px;
}
.player-container .close-button {
  position: absolute;
  right: 5px;
  top: 10px;
  z-index: 2;
}
.isVisible {
  visibility: visible;
  width: 100%;
}
::ng-deep .IPC3D {
  width: 0;
}
::ng-deep .IPC3D o-ipc {
  height: 100%;
}
::ng-deep .IPC3D o-ipc .ipc_details,
::ng-deep .IPC3D o-ipc .ipc_details.open {
  transition: all ease 0.1s;
  width: 100vw;
}
::ng-deep .IPC3D o-ipc .panzoom {
  visibility: hidden;
  width: 0;
}
::ng-deep .IPC3D o-ipc .openNav .ipc_details {
  width: calc(100vw - 500px + 30px);
}
::ng-deep .IPC3D o-ipc .table .openNav .ipc_details {
  width: calc(50vw + 30px);
}
::ng-deep .player-push-right {
  margin-left: 470px;
  transition: all ease 0.1s;
  width: calc(100% - 470px) !important;
}
::ng-deep .player-push-right.table-mode {
  margin-left: calc(50% - 30px) !important;
  width: calc(50% + 30px) !important;
}
@media only screen and (max-width: 1023px) {
  ::ng-deep .player-push-right {
    margin-left: auto;
    transition: all ease 0.1s;
    width: 100% !important;
  }
  ::ng-deep .IPC3D o-ipc .table .openNav .ipc_details,
  ::ng-deep .IPC3D o-ipc .openNav .ipc_details {
    margin-left: 30px;
    width: 100vw;
  }
}
@media print {
  :host {
    display: none;
  }
  ::ng-deep .IPC3D {
    width: auto;
  }
  ::ng-deep .IPC3D o-ipc .panzoom {
    visibility: visible;
    width: auto;
  }
  .switch-view-button-container {
    display: none;
  }
}
/*# sourceMappingURL=player.component.css.map */
